/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
import InfiniteScroll from 'react-infinite-scroll-component';
import CustomerItem from '../../components/customer/CustomerItem';
import CustomerWrite from './CustomerWrite';

import queryString from 'query-string';

class CustomerFaq extends Component {
  state = {
    board_id: 20,
    gotoPage: 1,
    pageSize: 20,
    boardList: [],
    category: 0,
    arrCategory: [],
    write: false,
    hasMore: false,
  };
  _isMounted = false;

  componentDidMount = () => {
    this._isMounted = true;
    const { board_id, gotoPage, category, arrCategory } = this.state;
    const { location } = this.props;
    const query = queryString.parse(location.search);

    let c = query.c;

    if (c === null || c === undefined || c === '') {
    } else {
      if (c.indexOf('|') > -1) {
        const arr = c.split('|');

        arr.map((item, index) => {
          arrCategory.push(item);
        });
      } else {
        arrCategory.push(c);
      }

      this.setState({
        category: parseInt(c),
        arrCategory: arrCategory,
      });
    }

    setTimeout(() => {
      this._getBoardData(board_id, gotoPage, category);
    }, 500);
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _getBoardData = async (board_id, gotoPage, category) => {
    const result = await this._getBoardDataApi(board_id, gotoPage, category);
    const intReturn = result.data[0].intReturn;
    const con = result.data[0].con;
    const pageCount = result.data[0].pageCount;
    const boardList = result.data[0].listData;

    ////console.log(intReturn)
    ////console.log(con)
    if (this._isMounted) {
      if (intReturn === 0) {
        if (con > 0) {
          //console.log('con > 0')
          this.setState({
            gotoPage: gotoPage + 1,
            con: con,
            boardList:
              gotoPage === 1
                ? boardList
                : this.state.boardList.concat(boardList),
            hasMore: pageCount < gotoPage ? false : true,
          });
        } else {
          //console.log('con < 0')
          this.setState({
            gotoPage: 1,
            con: con,
            boardList: boardList,
            hasMore: pageCount < gotoPage ? false : true,
          });
        }
      } else {
        //console.log('intReturn <> 0')
        this.setState({
          gotoPage: 1,
          con: con,
          boardList: [],
          hasMore: pageCount < gotoPage ? false : true,
        });
      }
    }
  };
  _getBoardDataApi = (board_id, gotoPage, category) => {
    const { apiUrl, loginId, authId } = this.props;
    const { arrCategory } = this.state;
    let paramCategory;
    //console.log(arrCategory.join('|'))
    if (arrCategory.length <= 0) {
      paramCategory = [0, 202, 203, 204, 206, 207, 208, 209, 210];
      paramCategory = paramCategory.join('|') + '|';
    } else {
      paramCategory = arrCategory.join('|') + '|';
    }
    console.log(paramCategory);

    //POST 방식으로 바꿀수도 있음...
    return axios
      .post(apiUrl + '/boardList_category', {
        params: {
          board_id: board_id,
          gotoPage: gotoPage,
          category: category,
          userid: loginId,
          authId: authId,
          arrCategory: paramCategory,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };
  _renderItem = () => {
    const { boardList } = this.state;

    const list = boardList.map((item, index) => {
      return (
        <CustomerItem
          key={index}
          idx={item.idx}
          refo={item.refo}
          step={item.step}
          re_level={item.re_level}
          userid={item.userid}
          nicName={item.nicName}
          board_id={item.board_id}
          title={item.title}
          writeDay={item.writeDay}
          charac_img={item.charac_img}
          categoryID={item.categoryID}
          categoryName={item.categoryName}
          content={item.content}
          replay_idx={item.replay_idx}
          onItemDel={this._onItemDel}
        />
      );
    });

    return list;
  };
  _totalCategory = (category) => {
    const { board_id, arrCategory } = this.state;
    let paramCategory;
    if (arrCategory.length <= 0) {
    } else {
      paramCategory = [];
      this.setState({
        arrCategory: paramCategory,
      });
    }

    setTimeout(() => {
      this._getBoardData(board_id, 1, category);
    }, 500);
  };
  _toggleCategory = (category) => {
    const { board_id, arrCategory } = this.state;
    // let temp;

    const a = arrCategory.findIndex((item, index) => {
      return item === category;
    });

    //console.log(a)

    if (a <= -1) {
      arrCategory.push(category);
    } else {
      arrCategory.splice(a, 1);
    }
    this.setState({
      arrCategory: arrCategory,
    });

    setTimeout(() => {
      this._getBoardData(board_id, 1, category);
    }, 500);

    /*
        if(arrCategory.indexOf(category) > -1) {
            //삭제
            //const temp = arrCategory.replace('|' + category + '|')
            const pos = arrCategory.indexOf(category)
            const temp = arrCategory.substr(pos, arrCategory.length)
            console.log(temp)
            const pos1 = temp.indexOf('|')

            const temp1 = arrCategory.substr(0, pos) + temp.substr(pos1, arrCategory.length)
            console.log(temp1)
            //console.log(temp)
        } else {
            //추가
            temp = arrCategory + category + '|'
            this.setState({
                arrCategory: temp
            })
        }
        */
  };
  _changeCategory = (category) => {
    const { board_id } = this.state;
    this.setState({
      category,
    });
    setTimeout(() => {
      this._getBoardData(board_id, 1, category);
    }, 500);
  };
  _showWrite = () => {
    const { write } = this.state;
    this.setState({
      write: !write,
    });
  };
  _onItemDel = async (idx) => {
    //console.log('asdfasdfasdfdas')

    const { board_id, category } = this.state;
    const { loginId } = this.props;
    if (loginId === null || loginId === undefined || loginId === '') {
      //console.log('not login')
    } else {
      //console.log('start del')
      const result = await this._onItemDelApi(idx);
      if (result) {
        const intReturn = result.data[0].intReturn;

        //console.log(intReturn)
        if (intReturn === 0) {
          toast.success('글이 성공적으로 삭제되었습니다.');
          this._getBoardData(board_id, 1, category);
        }
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };

  _onItemDelApi = (idx) => {
    const { apiUrl, loginId, authId, history } = this.props;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');

    return axios
      .post(
        apiUrl + '/boardDel',
        {
          params: {
            userid: loginId,
            authId: authId,
            idx: idx,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(idx);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async (idx) => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    const rt = localStorage.getItem('rt');

    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      this._onItemDel(idx);
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  render() {
    const { loginId } = this.props;
    const {
      board_id,
      boardList,
      gotoPage,
      hasMore,
      category,
      write,
      arrCategory,
    } = this.state;
    return (
      <Fragment>
        <div className="service_content">
          <h2>
            {/*<a className="on">자주 묻는 질문</a>*/}
            <a
              style={{ cursor: 'pointer' }}
              className={arrCategory.length === 0 ? 'on' : null}
              onClick={() => this._totalCategory('0')}
            >
              전체
            </a>
            <a
              style={{ cursor: 'pointer' }}
              className={arrCategory.indexOf('202') > -1 ? 'on' : null}
              onClick={() => this._toggleCategory('202')}
            >
              쇼핑
            </a>
            <a
              style={{ cursor: 'pointer' }}
              className={arrCategory.indexOf('203') > -1 ? 'on' : null}
              onClick={() => this._toggleCategory('203')}
            >
              로그인
            </a>
            <a
              style={{ cursor: 'pointer' }}
              className={arrCategory.indexOf('204') > -1 ? 'on' : null}
              onClick={() => this._toggleCategory('204')}
            >
              플레이어
            </a>
            {/*<a style={{cursor: 'pointer'}} className={category === 205 ? 'on' : null } onClick={()=>this._changeCategory(205)}>해지</a>*/}
            <a
              style={{ cursor: 'pointer' }}
              className={arrCategory.indexOf('206') > -1 ? 'on' : null}
              onClick={() => this._toggleCategory('206')}
            >
              상영회
            </a>
            <a
              style={{ cursor: 'pointer' }}
              className={arrCategory.indexOf('207') > -1 ? 'on' : null}
              onClick={() => this._toggleCategory('207')}
            >
              멤버십
            </a>
            <a
              style={{ cursor: 'pointer' }}
              className={arrCategory.indexOf('208') > -1 ? 'on' : null}
              onClick={() => this._toggleCategory('208')}
            >
              포인트
            </a>
            <a
              style={{ cursor: 'pointer' }}
              className={arrCategory.indexOf('209') > -1 ? 'on' : null}
              onClick={() => this._toggleCategory('209')}
            >
              콘텐츠
            </a>
            <a
              style={{ cursor: 'pointer' }}
              className={arrCategory.indexOf('210') > -1 ? 'on' : null}
              onClick={() => this._toggleCategory('210')}
            >
              서비스
            </a>
            {loginId === 'admin' ? (
              <a
                style={{ cursor: 'pointer', right: 80, position: 'absolute' }}
                className="on"
                onClick={this._showWrite}
              >
                FAQ등록
              </a>
            ) : null}
          </h2>
          {write ? (
            <CustomerWrite
              board_id={board_id}
              category={category}
              toggleWrite={this._showWrite}
              writeOk={this._getBoardData}
            />
          ) : (
            <div>
              <InfiniteScroll
                dataLength={this.state.boardList.length}
                next={() => this._getBoardData(board_id, gotoPage, category)}
                hasMore={hasMore}
                loader={
                  <div className="vod_loading">
                    {/*<img src="/img/vod/vod_loading.png"/>*/}
                  </div>
                }
                endMessage={<p style={{ textAlign: 'center' }}></p>}
                style={{ overflow: 'hidden', textAlign: 'center' }}
              >
                <table
                  width="100%"
                  border="0"
                  cellSpacing="0"
                  cellPadding="0"
                  className="customer_table2"
                >
                  <colgroup>
                    <col width="20" />
                    <col width="" />
                  </colgroup>
                  <tbody>{boardList ? this._renderItem() : null}</tbody>
                </table>
              </InfiniteScroll>
            </div>
          )}
        </div>

        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(CustomerFaq));
